module.exports = __webpack_public_path__ + "shortcut-arrow.png?aa531fb667298f37c47d4066770d031c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad windows/shortcut-arrow.png
// module id = 33
// module chunks = 0